// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.el-splitter-panel{box-sizing:border-box;flex-grow:0;overflow:auto;scrollbar-width:thin}`, "",{"version":3,"sources":["webpack://./../../../../node_modules/element-plus/theme-chalk/el-splitter-panel.css"],"names":[],"mappings":"AAAA,mBAAmB,qBAAqB,CAAC,WAAW,CAAC,aAAa,CAAC,oBAAoB","sourcesContent":[".el-splitter-panel{box-sizing:border-box;flex-grow:0;overflow:auto;scrollbar-width:thin}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
